import { DepositFrequency } from '~/models/deposits/DepositFrequency';

export const depositFrequencyOptions: { [key: string]: string } = {
    once: 'One Time',
    week: 'Weekly',
    month: 'Monthly (Most Popular)'
};

export const getFrequencyLabel = (property: DepositFrequency): string => {
    const frequencyLabel = depositFrequencyOptions[property];
    return frequencyLabel;
};
